/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cascade_Dialog_Error_Priority_ForcingInputs */



/**
* | output |
* | --- |
* | "Required in forcing mode" |
*
* @param {Cascade_Dialog_Error_Priority_ForcingInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const cascade_dialog_error_priority_forcing = /** @type {((inputs?: Cascade_Dialog_Error_Priority_ForcingInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cascade_Dialog_Error_Priority_ForcingInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Required in forcing mode")
	return /** @type {LocalizedString} */ ("Requis en mode forçage")
});